module.exports = __webpack_public_path__ + "static/assets/d2508a1afe421b677592c83fff401abd.svg";